import { Input, Select, Space } from 'antd';
import styled from 'styled-components';
import { blueDark01, blueLink, grayDark03, grayDark05, grayLight02 } from '../../../styles/colors';
const { Option } = Select;

export const Container = styled('div')`
    display: flex;
    align-items: center;
    gap: 6px;

    [type='number'] {
        -moz-appearance: textfield;
        width: 32px;
        height: 28px;
    }
`;

export const CurrentPageInput = styled(Input)`
    width: 32px;
    height: 28px;
    font-weight: normal;
    font-family: 'Proxima N W15 Bold';
    font-size: 13px;
    line-height: 16px;
    padding: 7px 11px !important;
    color: ${blueDark01};
    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
`;

export const CurrentNumberOfPage = styled('div')`
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: ${grayDark03};
    white-space: nowrap;
`;

export const PageArrowContainer = styled('div')`
    display: flex;
    align-items: center;
    color: ${grayDark05};
    :hover {
        cursor: pointer;
        color: ${blueLink};
    }
    :active {
        color: ${blueDark01};
    }
    &.disabled {
        cursor: auto;
        color: ${grayLight02};
    }
`;

export const ChangePageSizeOption = styled(Option)`
    background-color: red !important;
    .ant-select-selection-item {
        color: red;
    }
`;

export const PaginationSpace = styled(Space)`
    .ant-select-single .ant-select-selector .ant-select-selection-item,
    .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
        display: flex;
        align-items: center;
        font-weight: 400 !important;
        font-size: 13px !important;
        line-height: 16px !important;
        color: ${blueDark01};
    }
    .ant-select {
        font-weight: 400 !important;
        font-size: 13px !important;
        line-height: 16px !important;
        color: ${blueDark01};
        .ant-select-selector-item {
            font-weight: 400 !important;
            font-size: 13px !important;
            line-height: 16px !important;
            color: ${blueDark01};
        }
    }
`;

export const PageInputContainer = styled('div')`
    display: flex;
    gap: 8px;
    align-items: center;
`;
